export default {
  Back: 'Zurück',
  Next: 'Weiter',
  'About SignDict': 'Über SignDict',
  'Nearly done...': 'Gleich geschafft...',
  'SignDict Logo': 'SignDict Logo',
  PleaseReview: 'Wenn das Video dir gefällt, kannst du unter dem Video das Hochladen starten.',
  'Please wait...': 'Bitte warten...',
  'Login required': 'Anmeldung benötigt',
  PleaseLogin:
    'Damit wir die Videos einzelnen Nutzern zuweisen können, musst du dich anmelden bevor du das Video hochladen kannst.',
  'I already have a SignDict account': 'Ich habe schon ein SignDict Konto',
  'The email or password was wrong.': 'Die Email oder das Passwort war falsch.',
  Email: 'Email',
  Password: 'Passwort',
  'Forgot password?': 'Passwort vergessen?',
  Login: 'Anmelden',
  "I don't have a SignDict account": 'Ich brauche noch ein SignDict-Konto',
  'Oops, something went wrong! Please check the errors below.':
    'Uups, etwas ist schief gelaufen! Bitte überprüfe die markierten Felder.',
  Name: 'Name',
  Email: 'Email',
  Password: 'Passwort',
  'Confirm password': 'Passwort bestätigen',
  'Yes, I want to subscribe to the newsletter': 'Ja, ich will den Newsletter abonnieren.',
  Register: 'Registrieren',
  'Thank you for uploading your video. It will be published after a review within the next 48 hours.':
    'Danke für das Hochladen deines Videos. Es wird nach einer Überprüfung von uns in den nächsten 48 Stunden freigeschaltet.',
  'Sorry, there was a problem during the upload. Please contact us if this error appears more than once.':
    'Leider gab es ein Problem während des Hochladens. Bitte melde dich bei uns, wenn du diesen Fehler mehr als einmal siehst',
  'Back to SignDict': 'Zurück zu SignDict',
  'Upload video': 'Video hochladen',
  Uploading: 'Sende Video',
  'By pressing the upload button you will publish the video using the |CC-BY-SA 4.0| license.':
    'Nachdem du auf den "hochladen" Knopf gedrückst hast, veröffentlichst du das Video unter der |CC-BY-SA 4.0| Lizenz.',
  'You cannot record longer than 5 minutes.': 'Du kannst nicht länger als 5 Minuten aufnehmen.',
  'Start recording': 'Aufnahme starten',
  'Check your position': 'Überprüfe deine Position',
  Okay: 'Okay',
  'Please make sure that you are as close to the body outline as possible. If you think everything looks perfect, click on the "Start recording" on the lower right.':
    'Bitte versuche, so nah wie möglich an den abgebildeten Körperumriss zu kommen. Wenn du denkst das alles perfekt aussieht, klicke auf "Aufnahme starten" rechts unten.',
  Play: 'Abspielen',
  Pause: 'Pause',
  buffered: 'gepuffert',
  'Current time': 'Aktuelle Zeit',
  'Change playback rate': 'Abspielgeschwindigkeit ändern',
  'Toggle Fullscreen': 'Auf Vollbild umschalten',
  "Sadly there seems something wrong and we can't start the recording: ":
    'Leider ist etwas schief gelaufen und wir können die Aufnahme nicht starten: ',
  More: 'Mehr',
  SearchController: {
    WordNotFound: 'Leider konnte das Wort nicht gefunden werden. Bitte <a href="{{where}}">schlage es hier vor</a>.',
  },
  'Copy URL': 'URL kopieren',
};
